import React from "react";
import Loader from '../../../components/Loader';
import Page from '../../../components/Page';
import HTTPManager from "../../../utils/httpRequestManager";
import TableView from '../../../components/table/tableView';
import { toast, ToastContainer } from 'react-toastify';
import Iconify from '../../../components/Iconify';
import FormManager from "../../../components/formComponents/FormManager";
import schema from './schema.json';
import {Box, Grid, Card,  Container, Typography, Stack} from '@mui/material';
import FButton from '../../../components/formComponents/components/button';
import { checkButtonAccess } from "../../../utils/protector";
const getIcon = (name) => <Iconify icon={name} width={22} height={22} />;

export default class Discount extends React.Component{
    httpManager = new HTTPManager();

    constructor(){
        super();
        this.state={
            isLoading:false,
            schema:{},
            discountlist:[],
            addForm: false,
            selectedDiscount:{},
            columns:[
                {
                    field: 'mDiscountName',
                    headerName: 'Name',
                    flex: 1.5,
                    minWidth: 200,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                            {params.row.mDiscountName}
                        </div>
                    )
                },
                {
                    field: 'mDiscountType',
                    headerName: 'Type',
                    flex: 1,
                    minWidth: 150,
                    editable: false,
                    renderCell: (params) => (
                        <div style={{textTransform:'capitalize'}}>
                            {params.row.mDiscountType}
                        </div>
                    )
                },
                {
                    field: 'mDiscountValue',
                    headerName: 'Value',
                    flex: 0.8,
                    minWidth: 100,
                    editable: false,
                    renderCell: (params) => (
                        <div>
                            {params.row.mDiscountType ===  'Amount'? '$' + params.row.mDiscountValue : params.row.mDiscountValue+'%' }
                        </div>
                    )
                },
                {
                    field: 'Action',
                    headerName:'Actions',
                    flex: 1.2,
                    minWidth: 100,
                    renderCell: (params) => (
                        this.getActions(params)
                    ),
                }

            ]
        }
        this.handleCloseform = this.handleCloseform.bind(this); 
        this.updateRecord = this.updateRecord.bind(this);
        this.changePercentage = this.changePercentage.bind(this);
        this.onStateChange = this.onStateChange.bind(this);
    }

    onStateChange(value){

        const values = {...value}

        var schema = Object.assign({}, this.state.schema);
        var properties = Object.assign([], this.state.schema.properties);
        var props=[];
        var required = Object.assign([], this.state.schema.required)
        properties.forEach((field,i)=>{

            if(values.mDiscountType === 'Amount' && field.name === 'mDiscountValue'){
                field.format = 'currency'
                field.type = 'text'
                field.value = values[field.name];
            }
            else if(values.mDiscountType === 'Percentage' && field.name === 'mDiscountValue'){
                field.format = 'percentage'
                field.type = 'text'
                field.value = values[field.name];
            }
            else if(values.mDiscountDivisionType === 'Both' && field.name === 'mOwnerDivision'){
                field.format = 'percentage'
                field.type = 'text'
                field.value = values[field.name];
                if(required.indexOf('mOwnerDivision') === -1){
                    required.push('mOwnerDivision')
                }
            }
            else if(values.mDiscountDivisionType === 'Both' && field.name === 'mEmployeeDivision'){
                field.format = 'percentage'
                field.type = 'text'
                field.value = values[field.name];
                if(required.indexOf('mEmployeeDivision') === -1){
                    required.push('mEmployeeDivision')
                }
            }
            else if(values.mDiscountDivisionType !== 'Both' && field.name === 'mOwnerDivision'){
                field.format = 'percentage'
                field.type = 'hidden'
                field.value = values[field.name];
                if(required.indexOf('mOwnerDivision') !== -1){
                    let idx = required.indexOf('mOwnerDivision') 
                    required.splice(idx,1)
                }
            }
            else if(values.mDiscountDivisionType !== 'Both' && field.name === 'mEmployeeDivision'){
                field.format = 'percentage'
                field.type = 'hidden'
                field.value = values[field.name];
                if(required.indexOf('mEmployeeDivision') !== -1){
                    let idx = required.indexOf('mEmployeeDivision') 
                    required.splice(idx,1)
                }
            }
            else{ 
                field.value = values[field.name];
            }
            props.push(field);
            if(i === properties.length-1){ 
                schema.force = true
                //console.log("FORM", JSON.stringify(required))
                schema.required = required
                schema.properties = props; 
                this.setState({schema: schema},()=>{
                    this.setState({addForm: true})
                })
            }
        })
    }


    changePercentage(props, values){
        var schema = Object.assign({}, this.state.schema);
        var properties = Object.assign([], this.state.schema.properties);
        var schemaprops=[];
        properties.forEach((field,i)=>{ 
            if(props.name === 'mOwnerDivision' && field.name === 'mEmployeeDivision'){ 
                field.value = 100 - Number(props.value); 
            }
            else if(props.name === 'mEmployeeDivision' && field.name === 'mOwnerDivision'){ 
                field.value = 100 - Number(props.value);  
            }
            else{
                field.value = values[field.name]
            }
            schemaprops.push(field);
            if(i === properties.length-1){ 
                //console.log(schemaprops)
                schema.properties = schemaprops; 
                schema.force = true; 
                this.setState({schema: schema},()=>{
                    this.setState({addForm: true})
                })
            }
        });
    }

    updateRecord(row, status){ 
        this.setState({isLoading: true}, ()=>{
            this.httpManager.postRequest(`merchant/discounts/updateDiscount`, {mDiscountStatus: status, id: row.id}).then(res=>{
                //console.log(res.message);
                this.setState({isLoading: false});
                this.reloadData(res.message);
            })
        })
    }
    componentDidMount(){ 
        this.setState({schema: schema},()=>{
            //console.log(schema)
            this.reloadData();
        })
    }
    handleCloseform(){
        this.setState({addForm: false})
    }
    getActions(params){
        var detail = window.localStorage.getItem('userdetail')
        if(detail !== '' && detail !== undefined && detail !=='{}'){
          var userdetail = JSON.parse(detail);
          const btnBase = { border: 'none', borderRadius: '8px', padding: '5px 14px', fontSize: '0.78rem', fontWeight: 600, cursor: 'pointer', marginRight: '8px', transition: 'opacity 0.15s' };
        return <div style={{ display: 'flex', alignItems: 'center' }}>

               {(checkButtonAccess('Discount') || userdetail.userRole==='Owner') &&
                    <button style={{...btnBase, background:'transparent', border:'1.5px solid #0D1727', color:'#0D1727'}}
                        onClick={()=>this.openEdit(params.row)}>Edit</button>}

                {(checkButtonAccess('Discount') || userdetail.userRole==='Owner') && params.row.mDiscountStatus==='1' &&
                    <button style={{...btnBase, background:'#E53935', color:'#fff'}}
                        onClick={()=>{this.updateRecord(params.row, '0')}}>Deactivate</button>
                }
                {(checkButtonAccess('Discount') || userdetail.userRole==='Owner') && params.row.mDiscountStatus==='0' &&
                    <button style={{...btnBase, background:'#2E7D32', color:'#fff'}}
                        onClick={()=>{this.updateRecord(params.row, '1')}}>Activate</button>
                }
            </div>
        }
    }
    openEdit(data){
        var schema = Object.assign({}, this.state.schema);
        var properties = Object.assign([], this.state.schema.properties);
        var props=[];
        properties.forEach((field,i)=>{
            if (data.mDiscountDivisionType !== "Both") {
                if (field.name === "mOwnerDivision" || field.name === "mEmployeeDivision") {
                    field.type = "hidden"
                    data.mEmployeeDivision = ''
                    data.mOwnerDivision = ''
                }
                else {
                    field.value = data[field.name];
                }
            } else {
                if (field.name === "mOwnerDivision" || field.name === "mEmployeeDivision") field.type="text"
                field.value = data[field.name];
            }
            props.push(field);
            if(i === properties.length-1){
                props.push({
                    "component":"TextField", 
                    "type": "hidden", 
                    "minLength": 1,
                    "maxLength": 50,
                    "grid":6,
                    "name":"id",
                    "label":"id",
                    "placeholder":"id",
                    "value":data.id
                  })
                  props.push({
                      "component":"TextField", 
                      "type": "hidden", 
                      "minLength": 1,
                      "maxLength": 50,
                      "grid":6,
                      "name":"mDiscountId",
                      "label":"mDiscountId",
                      "placeholder":"mDiscountId",
                      "value":data.mDiscountId
                    })
                schema.properties = props; 
                this.setState({schema: schema,selectedDiscount: data},()=>{
                    this.setState({addForm: true})
                })
            }
        })
    }
    reloadData(msg=''){
        if(msg !== ''){ 
            toast.dismiss();
            toast.success(msg, {
                position: "top-center",
                autoClose: 5000,
                closeButton:false,
                hideProgressBar: true,
                closeOnClick: false,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
        this.setState({isLoading: true, addForm: false},()=>{
            this.httpManager.getRequest(`merchant/discounts/getDiscount`).then(response=>{
                this.setState({discountlist: response.data, isLoading: false});
            })

           
        })
    }
    openAdd(){
        this.setState({schema: {},selectedDiscount: {}},async ()=>{
            const defaultdiscounts = await this.httpManager.getRequest("/merchant/defaultdiscount/get").then(r=>r.data[0])
            var schemaobj = Object.assign({}, schema);

            var properties = Object.assign([],  schema.properties);
            var props=[];
            properties.forEach((field,i)=>{ 
                if(field.name === 'mDiscountType'){
                    field.value = 'Amount' 
                }
                else if(field.name === 'mDiscountDivisionType'){
                    field.value = 'Owner'
                }
                else if(field.name === 'mDiscountValue'){
                    field.format = 'currency'
                    field.value = ''
                }
                else if(field.name === 'mOwnerDivision' || field.name === 'mEmployeeDivision'){
                    field.format = 'percentage'
                    field.type = "hidden"
                    if (field.name === 'mOwnerDivision') field.value = defaultdiscounts.mOwnerDivision
                    if (field.name === 'mEmployeeDivision') field.value = defaultdiscounts.mEmployeeDivision
                }
                else{
                    field.value = ''
                }

                props.push(field);
                if(i === properties.length-1){
                    schemaobj.properties = props;
                }
            });
            //console.log(schemaobj)
            schemaobj.force= true;
            this.setState({schema:schemaobj}, ()=>{
                this.setState({addForm: true}) 
            })
        })
    }
    render(){
        return <Page title="Discount | Astro POS">
            {this.state.isLoading && <Loader show={this.state.isLoading} />}
            <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss={false}
            draggable={false}
            pauseOnHover={false}
            />
            {!this.state.addForm ?
                <Container maxWidth="xl">
                    {/* ── Header ── */}
                    <Stack direction="row" alignItems="center" justifyContent="space-between" mb={4}>
                        <div>
                            <Typography variant="h4" style={{ fontWeight: 700, color: '#0D1727' }}>
                                Discount
                            </Typography>
                            <Typography variant="body2" style={{ color: '#6B7280', marginTop: '2px' }}>
                                Manage discount types and values
                            </Typography>
                        </div>
                        {checkButtonAccess('Discount') &&
                            <button onClick={() => this.openAdd()} style={{
                                display: 'flex', alignItems: 'center', gap: '6px',
                                background: '#0D1727', color: '#fff', border: 'none',
                                borderRadius: '10px', padding: '10px 20px',
                                fontSize: '0.9rem', fontWeight: 700, cursor: 'pointer',
                                boxShadow: '0 2px 8px rgba(13,23,39,0.18)',
                            }}>
                                <span style={{ fontSize: '1.1rem', lineHeight: 1 }}>+</span> Add Discount
                            </button>
                        }
                    </Stack>

                    {/* ── Table card ── */}
                    <div style={{
                        background: '#fff', borderRadius: '16px',
                        boxShadow: '0 2px 12px rgba(0,0,0,0.07)', overflow: 'hidden',
                    }}>
                        <TableView
                            data={this.state.discountlist}
                            columns={this.state.columns} />
                    </div>
                </Container> : ''
            }
            {this.state.addForm && <Box sx={{ width: '100%' }}> 
                <Grid container spacing={3}  alignItems="center"  justifyContent="center" style={{marginLeft:0, marginRight:0,width:'100%', fontWeight:'bold'}} > 
                     <Grid item xs={12}>  
                        <Stack spacing={3}> 
                            <FormManager formProps={this.state.schema} formFunctions={{
                                onStateChange: this.onStateChange,
                                changePercentage: this.changePercentage
                            }} reloadData={(msg)=>this.reloadData(msg)} closeForm={()=>this.handleCloseform()}/>
                        </Stack>
                    </Grid>
                </Grid>
            </Box>}
            </Page>
            
    }
}